import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';
import {
  getAllLayersAndTables,
  ILayerDefinition,
} from '@esri/arcgis-rest-feature-service';
import { IItem } from '@esri/arcgis-rest-portal';
import {
  CalciteAction,
  CalciteButton,
  CalciteCard,
  CalciteValueList,
  CalciteValueListItem,
} from '@esri/calcite-components-react';
import { format } from 'date-fns';
import React, { ReactElement, useEffect, useState } from 'react';

interface Props {
  item: IItem;
  user?: ArcGISIdentityManager;
  onLayerSelected: (layerId: ILayerDefinition) => void;
  currentUrl: string;
}

export default function ItemCard({
  item,
  user,
  onLayerSelected,
  currentUrl,
}: Props): ReactElement {
  const [layersAndTables, setLayersAndTables] = useState<
    Array<ILayerDefinition>
  >([]);

  useEffect(() => {
    if (item.url) {
      getAllLayersAndTables({ url: item.url, authentication: user })
        .then((res) => {
          setLayersAndTables([...res.tables, ...res.layers]);
        })
        .catch(() => {});
    }
  }, [item.url, user]);
  return (
    <CalciteCard>
      <div
        slot="title"
        className="flex max-w-full items-center justify-between"
      >
        <span className="overflow-ellipsis min-w-0 overflow-hidden">
          {item.title}
        </span>
        <CalciteButton
          iconStart="launch"
          appearance="transparent"
          href={
            item.url ? `${item.url}${user ? `?token=${user.token}` : ''}` : ''
          }
          target="_blank"
        />
      </div>
      <div slot="subtitle" className="flex justify-between">
        <div className=" max-w-[50%] overflow-hidden overflow-ellipsis">
          {item.owner}
        </div>
        <div>{format(item.created, 'MMM do, yyyy')}</div>
      </div>

      <CalciteValueList>
        {layersAndTables.map((layerTable) => (
          <CalciteValueListItem
            value={layerTable.id}
            label={layerTable.name ?? 'No Name'}
            key={layerTable.id}
          >
            <CalciteAction
              slot="actions-end"
              appearance="transparent"
              scale="s"
              icon={
                currentUrl === `${item.url ?? ''}/${layerTable.id ?? ''}`
                  ? 'check-circle'
                  : 'plus-circle'
              }
              text="addLayer"
              onClick={() => {
                onLayerSelected(layerTable);
              }}
            />
          </CalciteValueListItem>
        ))}
      </CalciteValueList>
    </CalciteCard>
  );
}
